import React from 'react';
import DashboardLayout from '../DashboardLayout';

const ReportsLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default ReportsLayout;
